<ul class="list-group flex flex-col gap-2">
  <li class="px-0 list-group-item">
    <div class="flex justify-between w-full">
      <div class="items-center">
        <span class="font-medium"> Balance Inicial </span>
        <p class="mt-1 mb-0" bp-text-values-card>{{ balanceInitDate | date: 'longDate' }}</p>
      </div>

      <span class="text-right num">
        {{
          balanceInitAmount
            | currency: currency?.currencyCode : currency?.display : currency?.digitsInfo
        }}
      </span>
    </div>
  </li>
  <mat-divider class="my-1"></mat-divider>
  <li class="px-0 list-group-item">
    <div class="flex justify-between w-full">
      <div class="mb-1 font-medium name">Depósitos netos</div>
      <span class="text-right num">
        {{
          netDeposit | currency: currency?.currencyCode : currency?.display : currency?.digitsInfo
        }}
      </span>
    </div>
  </li>
  <li class="px-0 list-group-item sub text-secondary">
    <div class="flex justify-between w-full">
      <h5 class="mb-1 name">Depósitos</h5>
      <span class="ml-2 text-right num">{{
        deposits | currency: currency?.currencyCode : currency?.display : currency?.digitsInfo
      }}</span>
    </div>
  </li>
  <li class="px-0 list-group-item sub text-secondary">
    <div class="flex justify-between w-full">
      <h5 class="mb-1 name">Retiros</h5>
      <span class="ml-2 text-right num">{{
        withdrawals | currency: currency?.currencyCode : currency?.display : currency?.digitsInfo
      }}</span>
    </div>
  </li>
  <mat-divider class="my-1"></mat-divider>

  <li class="px-0 list-group-item total text-dark">
    <div class="flex justify-between w-full">
      <h5 class="mb-1 font-medium name">Ganancia / Pérdida</h5>
      <span class="text-right num">
        {{
          totalCurrentCapital && hasAllFinancialInstitutions
            ? (variation
              | currency: currency?.currencyCode : currency?.display : currency?.digitsInfo)
            : (variation
              | currency: currency?.currencyCode : currency?.display : currency?.digitsInfo)
        }}
      </span>
    </div>
  </li>
  <mat-divider class="my-1"></mat-divider>

  <li class="px-0 list-group-item">
    <div class="flex justify-between w-full">
      <div class="items-center">
        <span class="font-medium"> Balance Final </span>
        <p class="mt-1 mb-0" bp-text-values-card>
          {{
            totalCurrentCapital && hasAllFinancialInstitutions
              ? (dateFinalBalance | date: 'longDate')
              : (balanceTotalDate | date: 'longDate')
          }}
        </p>
      </div>

      <span class="text-right num">
        {{
          totalCurrentCapital && hasAllFinancialInstitutions
            ? (totalCurrentCapital
              | currency: currency?.currencyCode : currency?.display : currency?.digitsInfo)
            : (balanceTotalAmount
              | currency: currency?.currencyCode : currency?.display : currency?.digitsInfo)
        }}
      </span>
    </div>
  </li>
  @if (!isGeneralBalance) {
    <mat-divider class="my-1"></mat-divider>
    <li class="px-0 list-group-item">
      <div class="flex justify-between w-full gap-2">
        <div class="items-center">
          <span class="flex flex-col gap-1 font-medium">
            <span>
              Retorno individual (TIR)
              @if (irrAccumulatedUSD !== '') {
                <span>en CLP</span>
              }
            </span>

            @if (irrAccumulatedUSD !== '') {
              <span> Retorno individual (TIR) en USD </span>
            }
          </span>
          <p class="mt-1 mb-0 text-md" bp-text-values-card>
            Este es el retorno de tus inversiones, considerando el tamaño y momento de tus aportes y
            retiros. Como esta medida considera tu balance personal en cada momento es una buena
            medida para entender tus ganancias pero no es la recomendada para comparar diferentes
            inversiones o evaluar el portafolio.<a
              bp-link
              href="http://help.betterplan.cl/es/articles/4815391-como-se-calcula-la-rentabilidad"
              target="_blank"
              rel="noopener noreferrer"
            >
              Leer más sobre distintas formas de calcular la rentabilidad.
            </a>
          </p>
        </div>

        <span class="flex flex-col flex-shrink-0 gap-1 text-right">
          <span>
            {{ irrAccumulated }}
          </span>
          @if (irrAccumulatedUSD !== '') {
            <span>
              {{ irrAccumulatedUSD }}
            </span>
          }
        </span>
      </div>
    </li>
  }
</ul>
